module.exports = __webpack_public_path__ + "salesforce-3-1a419bc6053de1be0e44e634fb6b0b37.webp";